import { Component, HostListener, Inject, Input, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { PdfUrlsService } from '../../services/pdf-urls.service';
import { PdfReader } from '../../models/pages-model/form-general.model';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { LoadGeneralComponent } from '../../components-generals/load-general/load-general.component';
import { MatButtonModule } from '@angular/material/button';
@Component({
  selector: 'app-reader-pdf',
  standalone: true,
  imports: [CommonModule, MatIconModule, PdfViewerModule, MatButtonModule, LoadGeneralComponent],
  templateUrl: './reader-pdf.component.html',
  styleUrl: './reader-pdf.component.scss',
})
export class ReaderPdfComponent {
  @Input() pdfReader!: PdfReader;
  public pdfSource = '';
  public quotationId = 0;
  public isLoading = false;
  public page: number = 1;
  public isPage: boolean = true;
  public totalPages: number = 0;
  public zoom: number = 0.5;
  constructor(
    private pdfUrlsService: PdfUrlsService,
    @Optional() public dialogRef: MatDialogRef<ReaderPdfComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: { quotationId: number; ulrPDF: string },
  ) {}
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.ajustarZoomSegunPantalla(event.target.innerWidth);
  }

  ngOnInit(): void {
    this.ajustarZoomSegunPantalla(window.innerWidth);
    if (this.pdfReader || this.data) {
      this.loadPdfUrl();
    }
  }

  private loadPdfUrl(): void {
    let funtion = '';
    let bodyAux = '';
    if (this.pdfReader) {
      this.quotationId = this.pdfReader.quotationId;
      funtion = this.pdfReader.functionEvent?.ulrPDF ?? '';
      bodyAux = this.pdfReader.bodyAux;
    } else {
      this.quotationId = this.data.quotationId;
      funtion = this.data.ulrPDF;
    }
    this.isLoading = true;
    this.pdfUrlsService
      .colectionFuntions(this.quotationId, funtion as string, bodyAux)
      .subscribe((ress: any) => {
        // Asignamos el string con el prefijo directamente
        this.pdfSource = 'data:application/pdf;base64,' + ress;
        this.isLoading = false;
      });
  }

  public getPdf(): void {
    if (!this.pdfSource) {
      return;
    }
    const pdfBase64 = this.pdfSource.includes(',') ? this.pdfSource.split(',')[1] : this.pdfSource;
    const normalizedBase64 = pdfBase64.replace(/\s/g, '').replace(/-/g, '+').replace(/_/g, '/');
    const padding = normalizedBase64.length % 4;
    const base64ToDecode =
      padding === 0
        ? normalizedBase64
        : normalizedBase64.padEnd(normalizedBase64.length + (4 - padding), '=');
    const byteCharacters = atob(base64ToDecode);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(0)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `Cotizacion-${this.quotationId}.pdf`;
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  }

  public closeModal(): void {
    this.dialogRef.close(null);
  }

  // Se ejecuta cuando el PDF termina de cargar
  public afterLoadComplete(pdfData: any): void {
    this.totalPages = pdfData.numPages;
  }

  private ajustarZoomSegunPantalla(width: number): void {
    if (width >= 2560) {
      this.zoom = 0.5;
    } else if (width >= 1800) {
      this.zoom = 0.75;
    } else if (width >= 1080) {
      this.zoom = 1.0;
    } else {
      // En móviles, es mejor que ocupe el ancho total
      this.zoom = 1;
    }
  }
}
